import React from 'react';
import { Typography, Stack, Button } from '@mui/material';

import Logo1 from '../assets/images/LogoPurple.svg';
import Logo2 from '../assets/images/Logo2.svg';
import Logo3 from '../assets/images/Logo3.svg';
import Tache1 from '../assets/images/tache1.svg';
import Tache2 from '../assets/images/tache2.svg';
import Tache3 from '../assets/images/tache3.svg';

import Poster2024 from '../assets/images/Folks_Affiche.jpg'
import Poster2025 from '../assets/images/Folks_A3_2025_V2.png'

const About = () => {
  return (
    <Stack
      alignItems='center'
      gap={4}
      pt={4}
      pb={4}
      p={3}
      style={{
        color: '#000',
        textShadow: 'none',
        position: 'relative',
        overflow: 'hidden'
    }}>
      <svg style={{position: 'absolute', width: 0, height: 0}}>
        <defs>
          <filter id="inkSplatterAbout">
            <feTurbulence type="fractalNoise" baseFrequency="0.9" numOctaves="4" result="noise" />
            <feDisplacementMap in="SourceGraphic" in2="noise" scale="3" xChannelSelector="R" yChannelSelector="G" />
          </filter>
        </defs>
      </svg>
      {/* Taches grunge décoratives - Clusters */}
      {/* Cluster 1 - haut gauche */}
      <img src={Tache1} alt='' style={{position: 'absolute', top: '5%', left: '8%', width: '48px', transform: 'rotate(20deg)', zIndex: 999}} />
      <img src={Tache3} alt='' style={{position: 'absolute', top: '7%', left: '10%', width: '36px', transform: 'rotate(-40deg)', zIndex: 999}} />

      {/* Cluster 2 - haut droite */}
      <img src={Tache2} alt='' style={{position: 'absolute', top: '12%', right: '15%', width: '43px', transform: 'rotate(-30deg)', zIndex: 999}} />
      <img src={Tache1} alt='' style={{position: 'absolute', top: '14%', right: '13%', width: '31px', transform: 'rotate(65deg)', zIndex: 999}} />
      <img src={Tache3} alt='' style={{position: 'absolute', top: '10%', right: '17%', width: '27px', transform: 'rotate(110deg)', zIndex: 999}} />

      {/* Cluster 3 - milieu gauche */}
      <img src={Tache3} alt='' style={{position: 'absolute', top: '25%', left: '3%', width: '45px', transform: 'rotate(-50deg)', zIndex: 999}} />
      <img src={Tache2} alt='' style={{position: 'absolute', top: '27%', left: '5%', width: '34px', transform: 'rotate(80deg)', zIndex: 999}} />

      {/* Cluster 4 - milieu droite */}
      <img src={Tache1} alt='' style={{position: 'absolute', top: '40%', right: '10%', width: '47px', transform: 'rotate(30deg)', zIndex: 999}} />
      <img src={Tache2} alt='' style={{position: 'absolute', top: '42%', right: '8%', width: '35px', transform: 'rotate(-60deg)', zIndex: 999}} />

      {/* Cluster 5 - centre gauche */}
      <img src={Tache2} alt='' style={{position: 'absolute', top: '55%', left: '12%', width: '42px', transform: 'rotate(-10deg)', zIndex: 999}} />
      <img src={Tache3} alt='' style={{position: 'absolute', top: '57%', left: '14%', width: '30px', transform: 'rotate(90deg)', zIndex: 999}} />
      <img src={Tache1} alt='' style={{position: 'absolute', top: '53%', left: '10%', width: '26px', transform: 'rotate(-70deg)', zIndex: 999}} />

      {/* Cluster 6 - bas droite */}
      <img src={Tache3} alt='' style={{position: 'absolute', top: '70%', right: '8%', width: '44px', transform: 'rotate(-45deg)', zIndex: 999}} />
      <img src={Tache1} alt='' style={{position: 'absolute', top: '72%', right: '10%', width: '33px', transform: 'rotate(55deg)', zIndex: 999}} />

      {/* Cluster 7 - très bas gauche */}
      <img src={Tache2} alt='' style={{position: 'absolute', top: '85%', left: '18%', width: '40px', transform: 'rotate(-25deg)', zIndex: 999}} />
      <img src={Tache3} alt='' style={{position: 'absolute', top: '87%', left: '20%', width: '29px', transform: 'rotate(75deg)', zIndex: 999}} />

      {/* Taches isolées */}
      <img src={Tache1} alt='' style={{position: 'absolute', top: '15%', left: '30%', width: '38px', transform: 'rotate(-80deg)', zIndex: 999}} />
      <img src={Tache2} alt='' style={{position: 'absolute', top: '35%', right: '20%', width: '41px', transform: 'rotate(15deg)', zIndex: 999}} />
       <Stack direction='row' gap={0} justifyContent='center' alignItems='flex-end' sx={{display: {xs: 'none', md: 'flex'}, width: '100%', paddingBottom: '50px'}}>
          <img src={Logo1} alt='' style={{height: '120px', marginLeft: '-20px', marginBottom: '0px'}} />
          <img src={Logo2} alt='' style={{height: '120px', marginLeft: '-20px', marginBottom: '40px'}} />
          <img src={Logo3} alt='' style={{height: '120px', marginLeft: '-20px', marginBottom: '20px'}} />
          <img src={Logo1} alt='' style={{height: '120px', marginLeft: '-20px', marginBottom: '50px'}} />
          <img src={Logo2} alt='' style={{height: '120px', marginLeft: '-20px', marginBottom: '10px'}} />
        </Stack>
      <Stack gap={5} maxWidth='800px' alignItems='center'>
        <Typography 
          fontSize={{xs: 18, md: 22}} 
          align='center'>
          Folks Festival est le projet évènementiel phare de l’association Folks, 
          créée en mars 2023 et basée à Marseille. Il se déroule pendant la première 
          quinzaine d’avril et investit plusieurs lieux marseillais dans le but de 
          mettre en lumière des projets artistiques situés à la jonction entre musiques 
          traditionnelles et création contemporaine.
        </Typography>
        <Button
          onClick={() => {
            window.location.href='mailto:contact.folksfestival@gmail.com'
          }}
          style={{
            paddingTop: '15px',
            textDecoration: 'underline',
            color: '#000',
            fontSize: '16px',
            paddingLeft: '10px',
            paddingRight: '10px',
            borderRadius: '10px',
            width: '300px'
          }}>{`Nous contacter`}</Button>
       <Typography
          fontSize={{xs: 14, md: 18}} 
          style={{fontFamily: 'DroulersClarendon-Line', fontWeight: 700}}
          align='center'>
          Folks remercie chaleureusement l’ensemble des partenaires et ami·es qui rendent possible 
          l’existence du festival : le collectif de designers graphiques Super Terrain qui a réalisé 
          l’affiche de cette édition, les équipes des lieux qui accueillent nos événements, Camille Saint-Yves, 
          Bérengère Calbris, et tou·tes les bénévoles pour leur aide précieuse !
        </Typography>
        <div
          style={{
            height: '2px',
            width: '90%',
            margin: '2rem',
            backgroundColor: '#000'
            }}/>
        <Stack gap={3} alignItems='center'>
          <Typography fontSize={30}>Précédentes éditions</Typography>
          <Stack maxWidth={{xs: '100%', md: '400px'}}>
            <img src={Poster2025} alt='' style={{maxWidth: '100%'}} />
          </Stack>
          <Typography fontSize={26}>
          2 → 12 avril 2025
          </Typography>
          <Stack style={{
            borderRadius: '20px',
            border: '2px solid #000'
            }}
            p={3}>
            <Typography fontFamily='DroulersClarendon-Line' fontSize={18} align='center'>
            Espace Julien, Embobineuse, Le Molotov<br/>Le Petit 51, Meta
            </Typography>
          </Stack>
          <Typography textAlign='center' fontSize={22}>
            Clara! & Rrita Jashari (live) – David Bola (talk) – DJ Hidrataccioni –
            DJ Startup (live) – Emmanuelle Carinos Vasquez (talk) – Flegon (live) –
            Franssouax – KSU (ambient set) – Malesa (live) – Mona HKL (dj set commenté) –
            Nenĭa Iră (live) – Rostanga – Shlagga
          </Typography>
          <div
            style={{
              height: '2px',
              width: '90%',
              margin: '2rem',
              backgroundColor: '#000'
              }}/>
          <Stack maxWidth={{xs: '100%', md: '400px'}}>
            <img src={Poster2024} alt='' style={{maxWidth: '100%'}} />
          </Stack>
          <Typography fontSize={26}>
          3 → 12 avril 2024
          </Typography>
          <Stack style={{
            borderRadius: '20px',
            border: '2px solid #000'
            }}
            p={3}>
            <Typography fontFamily='DroulersClarendon-Line' fontSize={18} align='center'>
            Ateliers Jeanne Barret, Embobineuse<br/>Espace Julien, Espace Projet Club Coop
            </Typography>
          </Stack>
          <Typography textAlign='center' fontSize={22}>
            Emmanuelle Parrenin – Caïn و Muchi – Desastre –
            Ksu b2b Trae Joly – Lugal Lanbada – Maquis Son Sistèm –
            Mona HKL – Mystique – Paloma Colombe – Renaud Brizard –
            René Danger – Syqlone
          </Typography>
        </Stack>
      </Stack>
  </Stack>
  )
}

export default About